<script lang="ts" setup>
import type { LocationItemType } from '~/api/common';
import CommonAPI from '~/api/common';

defineProps<{
  dataTestId?: string;
}>();
const emit = defineEmits<{
  (event: 'select', value: LocationItemType): void;
}>();
const query = defineModel<string>('query', { default: '' });

const { t } = useI18n();

const suggestions = useState<LocationItemType[]>('locations-data', () => []);

const { execute, isLoading } = useRequest(CommonAPI.locations);
const options = computed(() =>
  suggestions.value
    .filter((el) => el.name.toLowerCase().includes(query.value.toLowerCase()))
    .slice(0, 40),
);

const getOptionKey = (value: LocationItemType) => value.code;
const getOptionLabel = (value: LocationItemType) => value.name;

const checkComparedItem = () => {
  if (!query.value) return;

  const item = options.value.find((el) => el.name === query.value);
  if (item) emit('select', item);
};

const onSelect = (value: LocationItemType) => {
  query.value = value.name;
  emit('select', value);
};

watch(query, () => checkComparedItem(), { immediate: true });

onMounted(() => {
  if (!suggestions.value.length) {
    execute()?.then((data) => {
      suggestions.value = data;
      checkComparedItem();
    });
  }
});
</script>

<template>
  <BaseSearchSelect
    v-model:query="query"
    @select="onSelect"
    :options="options"
    :get-option-key="getOptionKey"
    :get-option-label="getOptionLabel"
    :loading="isLoading"
    :placeholder="t('placeholder')"
    :data-test-id="dataTestId"
  >
    <template #label="{ option }">
      {{ option.name }}
    </template>
  </BaseSearchSelect>
</template>

<i18n>
ru:
  placeholder: Город

en:
  placeholder: City
</i18n>
